import React, { useState} from 'react';
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';

import pdf from './cv.pdf';

import './footer.scss';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const {name, email, message} = formData;

  const handleChangeInput =(e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  }

  const handleSubmit = ()=> {
    setLoading(true);

    const contact = {
     _type: 'contact',
     name:name,
     email:email,
     message:message,
    }

    client.create(contact)
      .then(() => {
      setLoading(false);
        setIsFormSubmitted(true);
    })
  }

  return (
    <>
    <h2 className="head-text">Take a coffe & chat with me</h2>
      <div className="app__footer-cards">
        
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:bhattakrishna111@gmail.com" className="p-text">
            bhattakrishna111@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="tel:+977 9741705911" className="p-text">
            +977 9741705911
          </a>
        </div>
        <div className="app__footer-card">
           <img src={images.download} alt="mobile" />
        <a href={pdf} download="FileName.pdf" className="p-text">Download</a>
        </div>

        {!isFormSubmitted ?
          <div className="app__footer-form app__flex">
            <div className="app__flex">
              <input type="text" placeholder='Your Name' value={name} name="name" onChange={handleChangeInput} className="p-text" />
            </div>
            <div className="app__flex">
              <input type="email" placeholder='Your Email' value={email} name="email" onChange={handleChangeInput} className="p-text" />
            </div>
            <div >
              <textarea className="p-text" placeholder="Your Message" name="message" value={message} onChange={handleChangeInput}>

              </textarea>
            </div>
            <button className="p-text" type="button" onClick={handleSubmit}>{loading ? 'Sending' : 'Sent Message'}</button>
          </div>

          : <div>
            <h3 className="head-text">Thank you for getting in touch!</h3>
          </div>
        }
    </div>
    
    </>
  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg'
)